import type { SidebarLogoProps } from './SidebarLogo';
import type { SidebarProfileProps } from './SidebarProfile';
import type { SidebarMenuProps } from './SidebarMenu';
import { Stack } from '@workramp/ui';
import { SidebarLogo } from './SidebarLogo';
import { SidebarMenu } from './SidebarMenu';
import { SidebarProfile } from './SidebarProfile';
import { Wrapper, SidebarBody, SidebarHeader } from './Sidebar.styles';

export interface SidebarProps extends SidebarLogoProps, SidebarProfileProps, SidebarMenuProps {}

export function Sidebar({ userId, logoUrl, enterpriseName, brandColor, items }: SidebarProps) {
  return (
    <Wrapper>
      <SidebarHeader>
        <Stack size={10}>
          <SidebarBody>
            <SidebarLogo logoUrl={logoUrl} enterpriseName={enterpriseName} />
          </SidebarBody>

          <SidebarBody>
            <SidebarProfile userId={userId} brandColor={brandColor} />
          </SidebarBody>
        </Stack>
      </SidebarHeader>

      <nav>
        <SidebarMenu items={items} />
      </nav>
    </Wrapper>
  );
}
